import api from "./api";
import { gvmPath } from "./apiPaths";

const ENDPOINT_NAME = "/initiate";

export type InitiateOnboardingInput = {
  name: string;
  email: string;
  mobile: string;
  mobile_country_code: string;
};

export async function initiateOnboarding(
  input: InitiateOnboardingInput,
): Promise<void> {
  await api.post(gvmPath(ENDPOINT_NAME), input);
}

const vipVendorOnboarding = { initiateOnboarding };
export default vipVendorOnboarding;
